import React, { useState } from 'react';
import uploadDocumentIcon from "../../assets/upload-documents-icon.png";
import pdfIcon from "../../assets/pdf.png";
import deleteIcon from "../../assets/delete-icon.png";
import Cookies from 'js-cookie';

const translations = {
  en: {
    uploadCV: "Upload Your CV",
    cvDescription: "Your resume helps us understand your experience, skills and professional journey to date. Don't have a resume? Then fill out your LinkedIn profile in the next step. Be aware that the less data you fill in, the less complete your personality profile will be.",
    selectFile: "Select File",
    or: "or",
    dragDrop: "Drag & Drop your file here",
    uploadedFile: "Uploaded File",
    next: "Next",
    fileSize: {
      bytes: "Bytes",
      kb: "KB",
      mb: "MB",
      gb: "GB"
    },
    alert: "Please upload a PDF file only"
  },
  nl: {
    uploadCV: "Upload Je CV",
    cvDescription: "Je CV helpt ons je ervaring, vaardigheden en professionele reis tot nu toe te begrijpen. Heb je geen CV? Vul dan je LinkedIn-profiel in in de volgende stap. Wees je ervan bewust dat hoe minder gegevens je invult, hoe minder compleet je persoonlijkheidsprofiel zal zijn.",
    selectFile: "Bestand Kiezen",
    or: "of",
    dragDrop: "Sleep & Plaats je bestand hier",
    uploadedFile: "Geüpload Bestand",
    next: "Volgende",
    fileSize: {
      bytes: "Bytes",
      kb: "KB",
      mb: "MB",
      gb: "GB"
    },
    alert: "Upload alleen een PDF-bestand"
  }
};

function UploadCV({ setActiveIndicator, cvFile, setCVFile, uploadProgress, setUploadProgress, uploadComplete, setUploadComplete, uploading, setUploading, isDragging, setIsDragging,
  uploadInterval, setShowUploadProgress
}) {
  const isDutch = Cookies.get('isDutch') === 'true';
  const t = translations[isDutch ? 'nl' : 'en'];

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 ' + t.fileSize.bytes;
    const k = 1024;
    const sizes = [t.fileSize.bytes, t.fileSize.kb, t.fileSize.mb, t.fileSize.gb];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleRemoveFile = () => {
    setCVFile(null);
    setUploadComplete(false);
    setUploadProgress(0);
    setShowUploadProgress(false);
  };

  const HandleNext = () => {
    setActiveIndicator(2);
    setShowUploadProgress(false)
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setCVFile(selectedFile);
      startUpload();
    } else {
      alert(t.alert);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile && droppedFile.type === 'application/pdf') {
      setCVFile(droppedFile);
      startUpload();
    } else {
      alert(t.alert);
    }
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const startUpload = () => {
    setShowUploadProgress(true);
    setUploadProgress(0);
    setUploadComplete(false);
    setUploading(true);
    uploadInterval = setInterval(() => {
      setUploadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(uploadInterval);
          setUploadComplete(true);
          setUploading(false);
          return 100;
        }
        return prev + 20;
      });
    }, 250);
  };

  return (
    <div>
      <div className=' mb-4'>
        <h1 className="text-5xl font-bold mb-4 text-primary">{t.uploadCV}</h1>
        <p className='w-1/2 m-auto'>{t.cvDescription}</p>
      </div>
      <div
        className={`border-dashed border-2 border-gray-400 p-8 mb-4 rounded-md ${isDragging ? 'bg-secondary' : 'bg-white'}`}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      >
        <input type="file" onChange={handleFileChange} className="hidden" accept=".pdf,application/pdf" />
        <button
          onClick={() => document.querySelector('input[type="file"]').click()}
          className="select-file-button mt-2 py-4 px-6 rounded-md bg-buttonColor flex gap-4 items-center m-auto"
        >
          <img src={uploadDocumentIcon} className='h-6 brightness-0 invert' />
          <p className='text-xl font-bold text-white'>{t.selectFile}</p>
        </button>
        <p className='mt-4 opacity-50'>{t.or}</p>
        <p className='mt-4'>{t.dragDrop}</p>
      </div>

      {cvFile && uploadComplete && (
        <div className=" rounded-md mb-8 mt-8">
          <h2 className="text-left mb-4 font-bold text-2xl">{t.uploadedFile}</h2>
          <div className="flex items-center justify-between">
            <div className="flex gap-2">
              <img className="size-10" src={pdfIcon} />
              <div className="text-left">
                <p className="font-medium text-gray-900">{cvFile.name}</p>
                <p className="text-sm text-gray-500">{formatFileSize(cvFile.size)}</p>
              </div>
            </div>
            <span className="cursor-pointer" onClick={handleRemoveFile}><img className="size-6" src={deleteIcon} /></span>
          </div>
        </div>
      )}

      {(
        <div className="flex gap-2 mt-4 justify-end">
          <button
            className="py-2 px-4 rounded-md bg-buttonColor text-white border"
            onClick={HandleNext}
          >
            {t.next}
          </button>
        </div>
      )}
    </div>
  );
}

export default UploadCV;